/**
 * AppleSignInButton — Continue with Apple.
 *
 * The web flow is redirect-based (Apple's rule for web is
 * response_mode=form_post — no popup, no JS SDK required). We call
 * our backend to get the fully-formed authorize URL (backend generates
 * a one-time state token) and then set window.location.href to it.
 * Apple bounces the user back to /api/auth/apple/callback which sets
 * cookies and 303-redirects to /account.
 */
import { useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { toast } from "sonner";

const API = process.env.REACT_APP_BACKEND_URL || (typeof window !== "undefined" ? window.location.origin : "");
export default function AppleSignInButton() {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);

  async function start() {
    setBusy(true);
    try {
      const { data } = await axios.get(
        `${API}/api/auth/apple/authorize-url`, { withCredentials: true });
      if (!data?.url) throw new Error("Apple authorize URL missing");
      window.location.href = data.url;
    } catch (err) {
      toast.error(err?.response?.data?.detail
                    || t("login_apple_failed"));
      setBusy(false);
    }
  }

  return (
    <button
      type="button"
      onClick={start}
      disabled={busy}
      data-testid="login-apple-signin-button"
      className="w-full flex items-center justify-center gap-3 bg-black hover:bg-[#111] text-white rounded-full h-12 px-4 font-medium transition-colors"
    >
      <svg width="18" height="18" viewBox="0 0 384 512" fill="currentColor" aria-hidden="true">
        <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"/>
      </svg>
      <span>{busy ? t("login_redirecting") : t("login_continue_apple")}</span>
    </button>
  );
}
